<template>
  <div class="pr-2 pl-2 mt-5">
    <div class="vx-row">
      <div class="vx-col sm:w-full w-full md:w-12/12">
        <div
          class="vx-row"
        >
          <div class="vx-col md:w-1/3 sm:w-full w-full">
            <report-statistics-item-card
              class="mb-5 queue-status-report-item"
              :title="$t('total_income')"
              :is-loading="isLoading"
              :display="queueDetails.totalIncome"
            />
          </div>

          <div class="vx-col md:w-1/3 sm:w-full w-full">
            <report-statistics-item-card
              class="mb-5 queue-status-report-item answer-call"
              :title="$t('answered')"
              :is-loading="isLoading"
              :display="queueDetails.answered"
            />
          </div>
          <div class="vx-col md:w-1/3 sm:w-full w-full">
            <report-statistics-item-card
              class="mb-5 queue-status-report-item"
              :title="$t('response_rate')"
              :display="`${queueDetails.responseRate}%`"
              :is-loading="isLoading"
            />
          </div>
        </div>
        <div
          class="vx-row"
        >
          <div class="vx-col md:w-1/3 sm:w-full w-full">
            <report-statistics-item-card
              class="mb-5 queue-status-report-item"
              :title="$t('real_income')"
              :is-loading="isLoading"
              :display="queueDetails.realIncome"
            />
          </div>

          <div class="vx-col md:w-1/3 sm:w-full w-full">
            <report-statistics-item-card
              class="mb-5 queue-status-report-item answer-call"
              :title="$t('real_answered')"
              :is-loading="isLoading"
              :display="queueDetails.realAnswer"
            />
          </div>
          <div class="vx-col md:w-1/3 sm:w-full w-full">
            <report-statistics-item-card
              class="mb-5 queue-status-report-item"
              :title="$t('real_response_rate')"
              :display="`${queueDetails.realResponseRate}%`"
              :is-loading="isLoading"
            />
          </div>
        </div>
        <div
          class="vx-row"
        >
          <div class="vx-col md:w-1/3 sm:w-full w-full">
            <report-statistics-item-card
              class="mb-5 queue-status-report-item"
              :title="$t('estimated_wait_time')"
              :display="queueDetails.estimatedWaitTime"
              :is-loading="isLoading"
            />
          </div>

          <div class="vx-col md:w-1/3 sm:w-full w-full">
            <report-statistics-item-card
              class="mb-5 queue-status-report-item abandonment"
              :title="$t('abandonment_issue')"
              :is-loading="isLoading"
              :display="queueDetails.abandonmentIssue"
            />
          </div>
          <div class="vx-col md:w-1/3 sm:w-full w-full">
            <report-statistics-item-card
              class="mb-5 queue-status-report-item"
              :title="$t('call_pending')"
              :display="queueDetails.callPending"
              :is-loading="isLoading"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportStatisticsItemCard from '@/components/cards/ReportStatisticsItemCard'
import Node from '@/models/Node'
import Queue from '@/models/Queue'
import io from 'socket.io-client'

export default {
  name: 'Window.Queues.Status.Report.Cdr',
  components: {
    ReportStatisticsItemCard
  },
  data () {
    return {
      socket: null,
      server: {},
      queueStatusNode: {},
      queueDetails: {
        totalIncome: 0,
        answered: 0,
        responseRate: 0,
        realIncome: 0,
        realAnswer: 0,
        realResponseRate: 0,
        estimatedWaitTime: '00:00:00',
        abandonmentIssue: 0,
        callPending: 0,
      },
      isLoading: true,
      refreshInterval: null
    }
  },
  computed: {
    queue () {
      return this.$route.query.queue
    }
  },
  async mounted () {
    document.title = this.$t('queues')

    const response = await Node.getServerAndNodeByLoggedInUser()
    this.server = response.data.server
    this.queueStatusNode = response.data.server.queue_status

    // socket setup
    this.socket = io.connect(
      `${this.queueStatusNode.domain}:${this.queueStatusNode.port}/${this.queueStatusNode.pivot.namespace}`,
      { query: { queueno: this.queue }, transports: ['websocket'] }
    )

    this.socket.on('connect', this.getInitialExtensions)
    this.socket.on('message', this.getMessage)

    this.getDataFromCDR()
    this.refreshInterval = setInterval(this.getDataFromCDR, 5000)

  },
  beforeDestroy () {
    // cleanup
    if (this.socket) {
      this.socket.disconnect()
    }
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
    }
  },
  methods: {
    getInitialExtensions () {
      this.socket.emit('get-initial-extensions')
    },
    getMessage (data) {
      if (data.api_type === 'queue') {
        this.manageQueueDetails(data)
      }
      this.isLoading = false
    },
    manageQueueDetails (data) {

      this.queueDetails.estimatedWaitTime = (data.holdtime == '') ? '00:00:00' : data.holdtime
      // this.queueDetails.abandonmentIssue = (isNaN(data.calls_notanswered) || data.calls_notanswered == '') ? 0 : parseInt(data.calls_notanswered)
      this.queueDetails.callPending = (isNaN(data.noofcalls) || data.noofcalls == '') ? 0 : parseInt(data.noofcalls)

    },
    async getDataFromCDR () {
      const queueResponse = await Queue.cdrStatusReport()
      const q = queueResponse.data

      const updated = {
        abandonmentIssue: q.abandonmentIssue,
        totalIncome: q.totalIncome,
        answered: q.answered,
        responseRate: q.totalIncome > 0
          ? ((q.answered * 100) / q.totalIncome).toFixed(2)
          : 0,
        realIncome: q.realIncome,
        realAnswer: q.realAnswer,
        realResponseRate: q.realIncome > 0
          ? ((q.realAnswer * 100) / q.realIncome).toFixed(2)
          : 0
      }

      this.queueDetails = { ...this.queueDetails, ...updated }
    }
  }
}
</script>

<style lang="scss">
.queue-status-report-item div:nth-child(1) {
  background-color: #115377;
}
.queue-status-report-item div:nth-child(1) h4 {
  color: #fff !important;
  font-size: 2em;
}
.queue-status-report-item div:nth-child(2) {
  color: #115377;
  font-size: 2.5em;
  font-weight: bold;
  background-color: #fff;
}
.queue-status-report-item div.vx-card__body {
  padding: 20px 15px !important
}
.queue-status-report-item.answer-call div:nth-child(1) {
  background-color: lightgreen;
}
.queue-status-report-item.answer-call div:nth-child(1) h4 {
  color: green !important;
  font-size: 2em;
}
.queue-status-report-item.answer-call div:nth-child(2) {
  color: green;
}
.queue-status-report-item.abandonment div:nth-child(1) {
  background-color: #b481e7;
}
.queue-status-report-item.abandonment div:nth-child(1) h4 {
  color: purple !important;
  font-size: 2em;
}
.queue-status-report-item.abandonment div:nth-child(2) {
  color: purple;
}
</style>
